import React, { useEffect, useState } from "react";
import { Box, Typography, FormControlLabel, Checkbox, Divider, Grid, CircularProgress } from '@mui/material';
import { Formik, Form, } from 'formik';
import * as Yup from 'yup';
import CustomButton from "../common/CustomButton";
import CustomTextField from "../common/CustomTextField";
import CustomAutocomplete from '../common/CustomAutoComplete';
import { genericPost } from '../../services/authServices';
import { Creact_LEADS } from '../../services/apiRoutes';
import { getStates, getCities } from "../../services/CommonServices";
import CustomTextarea from "../common/CustomTextarea";
import { ClearRounded, SaveRounded } from "@mui/icons-material";
import CustomStyle from "../common/CustomStyle";
import CustomMobileField from "../common/CustomMobileField";
import { t } from "../../constants/translationHelper";

const leadValidationSchema = Yup.object().shape({
  leadOwner: Yup.string().required('leads Owner is required'),
  clientCompanyId: Yup.string().required('Company is required'),
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  title: Yup.string().required('Title is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  mobile: Yup.string()
    .required('Mobile is required'),
  leadSourceId: Yup.string().required('Lead Source is required'),
  leadStatusId: Yup.string().required('Lead Status is required'),
  industry: Yup.string().required('Industry is required'),
  expectedDate: Yup.date().required('Expected Date is required'),
  emailOptOut: Yup.number().required('Email Opt-Out is required'),
  street: Yup.string().required('Street is required'),
  countryId: Yup.string().required('Country is required'),
  stateId: Yup.string().required('State is required'),
  cityId: Yup.string().required('City  is required'),
  businessGroup: Yup.number().required('Business Group is required').integer('businessGroupId ID must be an integer'),
});

const LeadForm = ({ handleClose, businessGroup, industryType, rating, leadSource, leadStatus, conutries, getLeadList, setMessage, getAllLead, clientCompany, leadOwner, titles }) => {

  const handleSubmit = async (values, { setSubmitting }) => {

    try {
      const response = await genericPost(Creact_LEADS, values, {
      });

      if (response.status === 201) {
        setMessage({
          open: true,
          text: response?.data?.message || "Lead added successfully",
          type: "success",
        });
        getLeadList()
        setTimeout(() => {
          handleClose()
        }, 3000)
        handleClose()
      } else {
        alert('Something went wrong');
      }
    } catch (error) {
      alert('Something went wrong');
    } finally {
      setSubmitting(false);
    }
  };

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [formData, setFormData] = useState({
    leadOwner: '',
    firstName: '',
    lastName: '',
    annualRevenue: '',
    title: '',
    email: '',
    phone: '',
    phonecodeId: '',
    mobile: '',
    leadSourceId: '',
    leadStatusId: '',
    industry: '',
    numberOfEmployees: '',
    rating: '',
    expectedDate: '',
    emailOptOut: 0,
    businessGroup: '',
    secondaryEmail: '',
    street: '',
    countryId: '',
    stateId: '',
    cityId: '',
    clientCompanyId: '',
    zipCode: '',
    description: '',
  })


  const handleChangeCountry = async (newValue) => {
    const countryId = newValue ? newValue.id : '';
    if (countryId) {
      const stateData = await getStates({ id: countryId });
      setStates(stateData);
      setCities([]);
    } else {
      setStates([]);
      setCities([]);
    }
  };

  const handleChangeState = async (newValue) => {
    const stateId = newValue ? newValue.id : '';
    if (stateId) {
      const cityData = await getCities({ id: stateId });
      setCities(cityData);
    } else {
      setCities([]);
    }
  };


  useEffect(() => {
    setFormData({
      leadOwner: '',
      firstName: getAllLead?.user?.firstName,
      lastName: '',
      annualRevenue: '',
      title: '',
      email: '',
      phone: '',
      mobile: '',
      phonecodeId: '',
      leadSourceId: '',
      leadStatusId: '',
      industry: '',
      numberOfEmployees: '',
      rating: '',
      expectedDate: '',
      emailOptOut: 0,
      businessGroup: '',
      secondaryEmail: '',
      street: '',
      countryId: '',
      stateId: '',
      cityId: '',
      zipCode: '',
      clientCompanyId: '',
      description: '',
    })
  }, [])

  return (
    <>
      <Box sx={{ mx: 'auto', mt: 0 }}>
        <Formik
          initialValues={formData}
          validationSchema={leadValidationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
            <Form>
              <Grid container spacing={1} style={CustomStyle.container}>
                <Grid item xs={4} md={2}>
                  <Typography sx={{ fontWeight: 600 }} style={CustomStyle.title}>
                    {t("Create Leads")}
                  </Typography>
                </Grid>
                <Grid item xs={8} md={10} style={CustomStyle.buttonContainer}>
                  <Box style={CustomStyle.buttonBox}>
                    <CustomButton
                      startIcon={<SaveRounded />}
                      title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                      size="small"
                      variant="contained"
                      type="submit"
                      disabled={isSubmitting}
                    />
                    <CustomButton
                      startIcon={<SaveRounded />}
                      title=" Save and New"
                      size="small"
                      variant="contained"
                    />
                    <CustomButton
                      startIcon={<ClearRounded />}
                      title="Cancel"
                      size="small"
                      variant="contained"
                      onClick={handleClose}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Divider />
              <Grid container spacing={1} style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: '5px' }}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomAutocomplete
                    options={leadOwner}
                    fieldLabel="leads Owner"
                    getOptionLabel={(option) => option.title}
                    value={leadOwner.find((option) => option.id === values.leadOwner) || null}
                    onChange={(e, newValue) => setFieldValue('leadOwner', newValue ? newValue.id : '')}
                    placeholder="Select Lead Owner"
                    required={true}
                    error={touched.leadOwner && !!errors.leadOwner}
                    helperText={touched.leadOwner && errors.leadOwner}
                  />

                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomAutocomplete
                    options={clientCompany}
                    fieldLabel="Select Company"
                    required={true}
                    getOptionLabel={(option) => option.title}
                    value={clientCompany.find((option) => option.id === values.clientCompanyId) || null}
                    onChange={(e, newValue) =>
                      setFieldValue('clientCompanyId', newValue ? newValue.id : '')
                    }
                    placeholder="Select Company"
                    error={touched.clientCompanyId && !!errors.clientCompanyId}
                    helperText={touched.clientCompanyId && errors.clientCompanyId}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomAutocomplete
                    options={titles}
                    fieldLabel="Title"
                    required={true}
                    getOptionLabel={(option) => option.title}
                    value={titles.find((option) => option.id === values.title) || null}
                    onChange={(e, newValue) => setFieldValue('title', newValue ? newValue.id : '')}
                    placeholder="Select Title"
                    error={touched.title && !!errors.title}
                    helperText={touched.title && errors.title}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomTextField
                    name="firstName"
                    fieldLabel="firstName"
                    required={true}
                    value={values.firstName}
                    onChange={handleChange}
                    placeholder="Enter firstName"
                    error={touched.firstName && !!errors.firstName}
                    helperText={touched.firstName && errors.firstName}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomTextField
                    name="lastName"
                    fieldLabel="Last Name"
                    required={true}
                    value={values.lastName}
                    onChange={handleChange}
                    placeholder="Enter Last Name"
                    error={touched.lastName && !!errors.lastName}
                    helperText={touched.lastName && errors.lastName}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomTextField
                    name="email"
                    fieldLabel="Email"
                    required={true}
                    value={values.email}
                    onChange={handleChange}
                    placeholder="Enter Email"
                    error={touched.email && !!errors.email}
                    helperText={touched.email && errors.email}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomTextField
                    type="number"
                    name="phone"
                    fieldLabel="Phone"
                    value={values.phone}
                    onChange={handleChange}
                    placeholder="Enter Phone"

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomMobileField
                    type="number"
                    name="mobile"
                    fieldLabel="Mobile"
                    required={true}
                    value={values.mobile}
                    onChange={handleChange}
                    placeholder="Enter Mobile"
                    error={touched.mobile && !!errors.mobile}
                    helperText={touched.mobile && errors.mobile}
                    countryCode={conutries.find((c) => c.id === values.phonecodeId)}
                    setFieldValue={setFieldValue}
                  />

                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomAutocomplete
                    options={leadSource}
                    fieldLabel="Select Source"
                    required={true}
                    getOptionLabel={(option) => option.title}
                    value={leadSource.find((option) => option.id === values.leadSourceId) || null}
                    onChange={(e, newValue) =>
                      setFieldValue('leadSourceId', newValue ? newValue.id : '')
                    }
                    placeholder="Select Source"
                    error={touched.leadSourceId && !!errors.leadSourceId}
                    helperText={touched.leadSourceId && errors.leadSourceId}

                  />

                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomAutocomplete
                    options={leadStatus}
                    fieldLabel="Select Lead Status"
                    required={true}
                    getOptionLabel={(option) => option.title}
                    value={leadStatus.find((option) => option.id === values.leadStatusId) || null}
                    onChange={(e, newValue) =>
                      setFieldValue('leadStatusId', newValue ? newValue.id : '')
                    }
                    placeholder="Select Lead Status"
                    error={touched.leadStatusId && !!errors.leadStatusId}
                    helperText={touched.leadStatusId && errors.leadStatusId}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomAutocomplete
                    options={industryType}
                    fieldLabel="Select Industry"
                    required={true}
                    getOptionLabel={(option) => option.title}
                    value={industryType.find((option) => option.id === values.industry) || null}
                    onChange={(e, newValue) =>
                      setFieldValue('industry', newValue ? newValue.id : '')
                    }
                    placeholder="Select Industry"
                    error={touched.industry && !!errors.industry}
                    helperText={touched.industry && errors.industry}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomTextField
                    name="numberOfEmployees"
                    fieldLabel="Number of Employees"
                    type="number"
                    value={values.numberOfEmployees}
                    onChange={handleChange}
                    placeholder="Enter Number of Employees"

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomTextField
                    name="annualRevenue"
                    fieldLabel="Annual Revenue"
                    type="number"
                    value={values.annualRevenue}
                    onChange={handleChange}
                    placeholder="Enter Annual Revenue"

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomAutocomplete
                    options={rating}
                    fieldLabel="Select Rating"

                    getOptionLabel={(option) => option.title}
                    value={rating.find((option) => option.id === values.rating) || null}
                    onChange={(e, newValue) =>
                      setFieldValue('rating', newValue ? newValue.id : '')
                    }
                    placeholder="Select Rating"

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomTextField
                    name="expectedDate"
                    fieldLabel="Expected Date"
                    required={true}
                    type="date"
                    value={values.expectedDate}
                    onChange={handleChange}
                    placeholder="Enter Expected Date"
                    error={touched.expectedDate && !!errors.expectedDate}
                    helperText={touched.expectedDate && errors.expectedDate}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="emailOptOut"
                        checked={values.emailOptOut === 1}
                        onChange={(e) => setFieldValue('emailOptOut', e.target.checked ? 1 : 0)}
                      />
                    }
                    label={t("Email Opt-Out")}
                    error={touched.emailOptOut && !!errors.emailOptOut}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                  <CustomAutocomplete
                    options={businessGroup}
                    fieldLabel="Business Group"
                    getOptionLabel={(option) => option.title}
                    value={businessGroup.find((option) => option.id === values.businessGroup) || null}
                    onChange={(e, newValue) =>
                      setFieldValue('businessGroup', newValue ? newValue.id : '')
                    }
                    placeholder="Enter Business Group"
                    required={true}
                    error={touched.businessGroup && !!errors.businessGroup}
                    helperText={touched.businessGroup && errors.businessGroup}
                  />

                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomTextField
                    name="secondaryEmail"
                    fieldLabel="Secondary Email"
                    value={values.secondaryEmail}
                    onChange={handleChange}
                    placeholder="Enter Secondary Email"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomTextField
                    name="street"
                    fieldLabel="Street"
                    required={true}
                    value={values.street}
                    onChange={handleChange}
                    placeholder="Enter Street"
                    error={touched.street && !!errors.street}
                    helperText={touched.street && errors.street}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomAutocomplete
                    options={conutries}
                    fieldLabel="Country"
                    required={true}
                    getOptionLabel={(option) => option.title}
                    value={conutries.find((option) => option.id === values.countryId) || null}
                    onChange={(e, newValue) => {
                      setFieldValue('countryId', newValue ? newValue.id : '');
                      handleChangeCountry(newValue);
                    }}
                    placeholder="Select Country"
                    error={touched.countryId && !!errors.countryId}
                    helperText={touched.countryId && errors.countryId}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                  <CustomAutocomplete
                    options={states}
                    fieldLabel="State"
                    required={true}
                    getOptionLabel={(option) => option.title}
                    value={states.find((option) => option.id === values.stateId) || null}
                    onChange={(e, newValue) => {
                      setFieldValue('stateId', newValue ? newValue.id : '');
                      handleChangeState(newValue);
                    }}
                    placeholder="Select State"
                    error={touched.stateId && !!errors.stateId}
                    helperText={touched.stateId && errors.stateId}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomAutocomplete
                    options={cities}
                    fieldLabel="City"
                    required={true}
                    getOptionLabel={(option) => option.title}
                    value={cities.find((option) => option.id === values.cityId) || null}
                    onChange={(e, newValue) => setFieldValue('cityId', newValue ? newValue.id : '')}
                    placeholder="Select City"
                    error={touched.cityId && !!errors.cityId}
                    helperText={touched.cityId && errors.cityId}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <CustomTextField
                    type="number"
                    name="zipCode"
                    fieldLabel="Zip Code"
                    value={values.zipCode}
                    onChange={handleChange}
                    placeholder="Enter Zip Code"

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                  <CustomTextarea
                    name="description"
                    fieldLabel="Note"
                    multiline
                    rows={4}
                    value={values.description}
                    onChange={handleChange}
                    placeholder="Enter Note"
                  />
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>


      </Box>
    </>
  );
};

export default LeadForm;
